import React from "react";

const trashBinContextData = {
	"docs/": {
		singularObjectNoun: "Document",
		cascadeDeleteDescription: (
			<div>
				Deleting Folders will delete{" "}
				<strong>
					all subfolders, and documents contained within those
					subfolders.
				</strong>
			</div>
		),
		cascadeDeleteDescriptionDependsOnFolderCount: true,
	},
	"email/": {
		singularObjectNoun: "Email",
		cascadeDeleteDescription: (
			<div>
				Deleting Folders will delete{" "}
				<strong>
					all subfolders, and emails contained within those
					subfolders.
				</strong>
			</div>
		),
		cascadeDeleteDescriptionDependsOnFolderCount: true,
	},
	"notes/": {
		singularObjectNoun: "Note",
		cascadeDeleteDescription: (
			<div>
				Deleting Folders will delete{" "}
				<strong>
					all subfolders, and matter notes contained within those
					subfolders.
				</strong>
			</div>
		),
		cascadeDeleteDescriptionDependsOnFolderCount: true,
	},
	"matters/": {
		singularObjectNoun: "Matter",
		cascadeDeleteDescription: (
			<div>
				Deleting Matters will delete{" "}
				<strong>
					all folders, documents, emails and matter notes contained
					within those Matters.
				</strong>
			</div>
		),
		cascadeDeleteDescriptionDependsOnFolderCount: false,
	},
	"clients/": {
		singularObjectNoun: "Client",
		cascadeDeleteDescription: (
			<div>
				Deleting Clients will <strong>NOT</strong> delete Matters
				associated with the Clients. No documents, emails, matter notes,
				folders, or Matters will be deleted.
			</div>
		),
		cascadeDeleteDescriptionDependsOnFolderCount: false,
	},
	"activity/": {
		singularObjectNoun: "Activity",
		cascadeDeleteDescription: <div></div>,
		cascadeDeleteDescriptionDependsOnFolderCount: false,
	},
};

function trashBinRedButtonText({
	selectedItems,
	trashPageContextWithTrailingSlash,
}) {
	const selectedObjectsCount = selectedItems
		? Object.keys(selectedItems.Object).length
		: 0;

	const selectedFoldersCount = selectedItems
		? Object.keys(selectedItems.Folder).length
		: 0;

	const totalSelectedItems = selectedObjectsCount + selectedFoldersCount;

	// eg: "Document"
	const objectSingularNoun =
		trashBinContextData[trashPageContextWithTrailingSlash]
			.singularObjectNoun;

	// eg: "Documents"
	const objectPluralNoun = objectSingularNoun + "s";

	// nothing selected
	if (totalSelectedItems === 0) {
		return `Permanently Delete all ${objectPluralNoun} in Trash Bin`;
	}

	// no folders selected
	if (selectedFoldersCount === 0) {
		return `Permanently Delete ${totalSelectedItems} selected ${selectedObjectsCount > 1 ? objectPluralNoun : objectSingularNoun}`;
	}

	// just folders selected
	if (selectedObjectsCount === 0) {
		return `Permanently Delete ${totalSelectedItems} selected ${selectedFoldersCount > 1 ? "Folders" : "Folder"}`;
	}

	// a combination of Objects and Folders
	// eg: "Permanently Delete 4 selected Items"
	return `Permanently Delete ${totalSelectedItems} selected Items`;
}

function getCascadeDeleteDescription({
	/*
		TODO: standardize the context, it sometimes has
		the trailing slash and sometimes doesnt:

			-all button: has trailing slash eg: matters/
			-shredder: no trailing slash
			-multiselect, then red button: no trailing slash
	
	*/
	trashPageContextWithUnknownTrailingSlash,
	objectTypeCount,
}) {
	let shouldShowCascadeDeleteDescription = true;

	let matchedContext = {};

	if (trashBinContextData[trashPageContextWithUnknownTrailingSlash]) {
		matchedContext =
			trashBinContextData[trashPageContextWithUnknownTrailingSlash];
	}
	if (trashBinContextData[trashPageContextWithUnknownTrailingSlash + "/"]) {
		matchedContext =
			trashBinContextData[trashPageContextWithUnknownTrailingSlash + "/"];
	}

	if (
		matchedContext.cascadeDeleteDescriptionDependsOnFolderCount &&
		objectTypeCount
	) {
		// if user is deleting, eg: 2 documents, they won't be shown
		// the description about cascade deleting folders

		// if user is deleting matters, clients, or at least 1 folder, we
		// show the cascade delete explaination
		if (!objectTypeCount.folder || objectTypeCount.folder === 0) {
			shouldShowCascadeDeleteDescription = false;
		}
	}
	return {
		cascadeDeleteDescription: matchedContext.cascadeDeleteDescription,
		shouldShowCascadeDeleteDescription,
	};
}

export { trashBinRedButtonText, getCascadeDeleteDescription };
